export var FooterNavigationStyles = {
  footer: {
    borderStyle: 'solid',
    borderTopWidth: 3,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    paddingBottom: 40
  }
};